import React from 'react';

export default {
  path: '/content/article',
  async action() {
    const { default: ContentArticleList } =
      await import('./ContentArticleList');
    return <ContentArticleList key={'list'} />;
  },
};
